/**
 * The SEYON NexGen wordmark.
 *
 * Two files, not one, because the artwork is two-tone: `logo_light.png` is the
 * pale version drawn for dark backgrounds, `logo_dark.png` the navy one for
 * light. Which is correct depends on the console's theme, and the theme can
 * change without this component re-rendering — the toggle writes
 * `data-theme` on `<html>` and nothing here is subscribed to it.
 *
 * So the swap is done in CSS rather than in JavaScript: both images are in the
 * DOM, and the stylesheet shows exactly one. That also means the right logo is
 * painted on the very first frame, with no flash of the wrong one while React
 * works out which theme it is in.
 */
export function Logo({ height = 26 }: { height?: number }) {
  return (
    <span className="brandmark" style={{ height }} role="img" aria-label="SEYON NexGen">
      <img className="brandmark__img brandmark__img--dark" src="/brand/logo_light.png" alt="" />
      <img className="brandmark__img brandmark__img--light" src="/brand/logo_dark.png" alt="" />
    </span>
  )
}
